import React, {Component} from "react";
import Notification from "grommet/components/Notification";
import ViewerEtatVsEtude from "./ViewerEtatVsEtude";
import ViewerSimple from "./ViewerSimple";
import ViewerOneCategory from "./ViewerOneCategory";
import { deepEqual } from "../../utils/shallowCompare";

export const SIMPLE = "SIMPLE";
export const ETAT_VS_ETUDE = "ETAT_VS_ETUDE";
export const ONE_CATEGORY = "ONE_CATEGORY";


export default class Viewer extends Component {
    state = {
        error: undefined
    };
    componentDidCatch(error) {
        this.setState({
            error
        });
    }

    componentWillReceiveProps(nextProps, _){
        if(!deepEqual(nextProps, this.props)){
            this.setState({
                error: undefined
            })
        }
    }

    render() {
        let { value, ...rest } = this.props;
        let { error } = this.state;
        if (error) {
            return (
                <Notification
                    state={`Une erreur s'est produite lors de l'affichage du résultat`}
                    message="Erreur"
                    status="critical"
                    size="large"
                />
            );
        }
        let newValue = JSON.parse(JSON.stringify(value));
        switch (newValue.typeVisualisation) {
            case SIMPLE:
                return <ViewerSimple series={newValue.series} {...rest} />;
            case ETAT_VS_ETUDE:
                return <ViewerEtatVsEtude series={newValue.series} {...rest} />;
            case ONE_CATEGORY:
                return <ViewerOneCategory series={newValue.series} option={newValue.visualisationOption} {...rest} />;
            default:
                return <div>Unknown typeVisualisation {JSON.stringify(newValue)}</div>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/computationApps/components/viewer/Viewer.js